import React from 'react';

function Timeup({ root, dir, level, number }) {
  return (
    <div className="questionContent questionEnding questionTimeup">
      <div className="questionTxt">
        <div className="questionTxtInner">
          <p className="txtTimeup">
            ざんねん!
            <br />
            時間切れじゃ!
          </p>
          <p className="txtLg">またチャレンジするのじゃ。</p>
        </div>
        <button
          onTouchStart={() => {}}
          className="questionBtn questionResetBtn"
          onClick={() => {
            root.dispatchEvent(
              new CustomEvent('reset', {
                detail: {
                  level: level + 1,
                  number: number + 1,
                },
              })
            );
            root.dataset.fade = '';
            root.dataset.status = 'hide';
          }}
        >
          <img src={dir + 'assets/img/btn-reset.png'} alt="もう一度トライ" />
        </button>
      </div>
    </div>
  );
}

export default Timeup;
